/**
 * 日期快捷选项：今天、昨天、一周前
 * @returns {{disabledDate(*): boolean, shortcuts: [{onClick(*): void, text: string},{onClick(*): void, text: string},{onClick(*): void, text: string}]}|boolean}
 */
export function getPickerOptions() {
    return {
        disabledDate(time) {
            return time.getTime() > Date.now();
        }, shortcuts: [{
            text: "今天", onClick(picker) {
                picker.$emit("pick", new Date());
            },
        }, {
            text: "昨天", onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 24);
                picker.$emit("pick", date);
            },
        }, {
            text: "一周前", onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", date);
            },
        }],
    };
}

/**
 * 日期快捷选项：最近一周、最近一个月、最近三个月
 * @param disabledBeforeToday 限制只能选择今天之前的
 * @returns {{shortcuts: [{onClick(*): void, text: string},{onClick(*): void, text: string},{onClick(*): void, text: string}]}}
 */
export function getDateScopeOptions(disabledBeforeToday) {
    return {
        disabledDate(time) {
            return disabledBeforeToday && (time.getTime() > Date.now());
        },
        shortcuts: [
            {
                text: '今天',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    picker.$emit('pick', [start, end]);
                }
            },
            {
                text: '昨天',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24);
                    end.setTime(end.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', [start, end]);
                }
            },
            {
                text: '过去三天',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                    picker.$emit('pick', [start, end]);
                }
            },
            {
                text: '最近一周',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [
                        start,
                        end
                    ]);
                }
            },
            {
                text: '最近一个月',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [
                        start,
                        end
                    ]);
                }
            },
            {
                text: '最近三个月',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [
                        start,
                        end
                    ]);
                }
            }
        ]
    };
}

export function getTableData() {
    return [{
        date: "2016-05-02",
        name: "王小虎",
        province: "上海",
        city: "普陀区",
        address: "上海市普陀区金沙江路 1518 弄",
        zip: 200333,
    }, {
        date: "2016-05-04",
        name: "王小虎",
        province: "上海",
        city: "普陀区",
        address: "上海市普陀区金沙江路 1517 弄",
        zip: 200333,
    }, {
        date: "2016-05-01",
        name: "王小虎",
        province: "上海",
        city: "普陀区",
        address: "上海市普陀区金沙江路 1519 弄",
        zip: 200333,
    }, {
        date: "2016-05-03",
        name: "王小虎",
        province: "上海",
        city: "普陀区",
        address: "上海市普陀区金沙江路 1516 弄",
        zip: 200333,
    }];
}

/**
 * mySpanMethod - 对表格中指定的列进行单元格合并
 *
 * @param {Array} tableData - 表格的数据，是一个对象数组，其中每个对象代表一行数据
 * @param {Array} colTempExclusion - 需要合并的列的信息，每个元素包含两个属性: prop（列的名称）和 index（列的下标）
 * @param {Number} columnIndex - 当前列的下标
 * @param {Number} rowIndex - 当前行的下标
 *
 * @returns {Object} 返回一个对象，包含两个属性: rowspan（行合并的数量）和 colspan（列合并的数量）
 *
 * @example
 *  // 使用示例：
 *  const tableData = [
 *      {name: "Tom", age: 25},
 *      {name: "Jerry", age: 26},
 *      {name: "Tom", age: 25}
 *  ];
 *  const colTempExclusion = [{prop: "name", index: 0}];
 *  const result = mySpanMethod(tableData, colTempExclusion, 0, 0);
 *  console.log(result);  // {rowspan: 2, colspan: 1}
 */
export function mySpanMethod(tableData, colTempExclusion, columnIndex, rowIndex) {
    // 所有列
    var props = Object.keys(tableData[0]);
    // 要合并的列名称
    var wantExcPropNames = [];
    // 需要合并的列下标
    var wantExcPropIndexs = [];
    colTempExclusion.forEach(item => {
        wantExcPropNames.push(item.prop);
        wantExcPropIndexs.push(item.index);
    });

    var spanAll = [];

    // 不要合并的列名称
    var notExcPropNames = [];
    props.forEach(item => {
        if (wantExcPropNames.indexOf(item) === -1) {
            notExcPropNames.push(item);
        }
    });

    // 正确的合并列排序
    var propNames = [];

    for (let i = 0; i < props.length; i++) {
        // 如果该下边不属于要合并的列下标
        if (wantExcPropIndexs.indexOf(i) === -1) {
            propNames.push(notExcPropNames[0]);
        }
        // 如果该下标属于要合并的列下标, 查找要合并的列里面与这个下标相同的列名称
        else {
            colTempExclusion.forEach(item => {
                if (item.index === i) {
                    propNames.push(item.prop);
                }
            });
        }
    }

    propNames.forEach(curName => {
        const data = tableData;
        var spanArr = [];
        let pos = 0;

        data.forEach((val, i) => {
            if (i === 0) {
                spanArr.push(1);
                pos = 0;
            } else {
                // 判断当前列数据与下一行的该列数据是否相同
                if (data[i][curName] === data[i - 1][curName] && wantExcPropNames.indexOf(curName) !== -1) {
                    // 每一列每一行的合并数量
                    spanArr[pos] += 1;
                    spanArr.push(0);
                } else {
                    spanArr.push(1);
                    pos = i;
                }
            }
        });

        // 把合并数据放入spanAll里面
        spanAll.push(spanArr);

    });

    try { // 得到行合并的数据
        const rowNum = spanAll[columnIndex][rowIndex];
        // 列合并
        const colNum = rowNum > 0 ? 1 : 0;
        // 当前位置的行合并和列合并数据
        return {
            rowspan: rowNum, colspan: colNum,
        };
    } catch (e) {
//        console.log(e);
    }
}

export function msg(result, app) {
    app.$nextTick(() => {
        app.$message({
            message: result.msg, type: result.code === 200 ? "success" : "error"
        });
    });
}

/**
 * element ui 中表格统计求和方法
 * @param noGetSumLabelArr 不计入统计的列标题
 * @param customSumValueArr 自定义求和的列及对应值 参数为map集合
 *                          [
 *                              {label: "第1期", value: "10000"},
 *                              {label: "第2期", value: "20000"}
 *                          ]
 * @param param 表格
 */
export function getSummariesPlus(param, noGetSumLabelArr, customSumValueArr) {

    const {
        columns, data
    } = param;
    // columns 每一列
    // data 每一行数据

    const sums = [];

    // 遍历每一列
    columns.forEach((column, index) => {

        // 首列不参与
        if (index === 0) {
            sums[index] = "合计";
            return;
        }
        // 不参与统计的列
        if (noGetSumLabelArr.indexOf(column.label) !== -1) {
            sums[index] = "";
            return;
        }

        // 自定义列设置自定义合计的值
        if (customSumValueArr != null) {
            for (let i = 0; i < customSumValueArr.length; i++) {
                var item = customSumValueArr[i];
                if (item.label === column.label) {
                    sums[index] = item.value;
                    return;
                }
            }
        }

        const values = data.map(item => {
            return Number(item[column.property]);
        });
        if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
                if (!isNaN(Number(curr))) {
                    return prev + curr;
                } else {
                    return prev;
                }
            }, 0);
        } else {
            sums[index] = "";
        }
    });
    return sums;
}

export function beforeUpload() {

}
